import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleService } from 'angular-l10n';
import { AuthenticationService } from '../../views/authentication/authentication.service';
import { navigation } from '../../_nav';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css']
})
export class AppHeaderComponent {
    navigation:any;
    route:any;
    constructor(public locale: LocaleService, private router: Router, public service: AuthenticationService) {
      this.navigation = navigation;
      this.route = router;
    }

    /** Select Language for localization of the App */
    selectLanguage(language: string): void {
      this.locale.setCurrentLanguage(language);
    }

    logout() {
      this.service.logout();
      //this.router.navigateByUrl('/welcome');
    }
    hasChildren(item) {
      return (item.children && item.children.length>0);
    }

    goToTagSelector() {
      this.router.navigate(['tags-strategy-selector']);
    }

    goToCDRStatus() {
      this.router.navigate(['cdr-status']);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/app-header/app-header.component.ts